import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '/#about',
    isRoute: false
  }, {
    name: 'Menu',
    href: '/menu',
    isRoute: true
  }, {
    name: 'Family',
    href: '/family',
    isRoute: true
  }, {
    name: 'Contact',
    href: '/#contact',
    isRoute: false
  }];
  const renderNavLink = (link: (typeof navLinks)[0], className: string) => {
    if (link.isRoute) {
      return <Link key={link.name} to={link.href} className={className} data-id="element-122">
          {link.name}
        </Link>;
    }
    if (location.pathname !== '/') {
      return <Link key={link.name} to={link.href} className={className} data-id="element-123">
          {link.name}
        </Link>;
    }
    return <a key={link.name} href={link.href.replace('/', '')} className={className} data-id="element-124">
        {link.name}
      </a>;
  };
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'shadow-xl' : ''}`} data-id="element-125">
      {/* Brick Facade Background */}
      <div className="absolute inset-0 brick-pattern opacity-100" data-id="element-126"></div>

      {/* Dark overlay for better contrast when scrolled */}
      <div className={`absolute inset-0 bg-black transition-opacity duration-300 ${isScrolled ? 'opacity-40' : 'opacity-20'}`} data-id="element-127"></div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="flex justify-between items-center h-24 md:h-32" data-id="element-129">
          {/* Desktop Left Nav */}
          <nav className="hidden md:flex space-x-8 flex-1" data-id="element-130">
            {navLinks.slice(0, 2).map(link => renderNavLink(link, 'text-cream font-medium tracking-wider hover:text-amber transition-colors text-shadow-sm uppercase text-sm'))}
          </nav>

          {/* Center Logo / Sign */}
          <Link to="/" className="flex-shrink-0 flex flex-col items-center justify-center relative z-10 group cursor-pointer py-2 no-underline" data-id="element-131">
            <h1 className="font-serif text-cream text-center uppercase flex flex-col items-center" data-id="element-132">
              <span className="text-lg md:text-xl tracking-[0.4em] mb-1 backlight-glow font-medium" data-id="element-133">
                Freddie
              </span>
              <span className="text-4xl md:text-5xl tracking-[0.15em] backlight-glow font-bold" data-id="element-134">
                Cheah
              </span>
            </h1>
          </Link>

          {/* Desktop Right Nav */}
          <nav className="hidden md:flex space-x-8 flex-1 justify-end items-center" data-id="element-135">
            {navLinks.slice(2).map(link => renderNavLink(link, 'text-cream font-medium tracking-wider hover:text-amber transition-colors text-shadow-sm uppercase text-sm'))}
            <a href="#reservation" className="bg-amber text-charcoal px-5 py-2 font-semibold tracking-wide uppercase text-sm hover:bg-cream transition-colors shadow-lg" data-id="element-136">
              Reserve
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-137">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-cream hover:text-amber p-2" data-id="element-138">
              {mobileMenuOpen ? <X size={28} data-id="element-139" /> : <Menu size={28} data-id="element-140" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-141">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-charcoal border-t border-amber/20 overflow-hidden" data-id="element-142">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-xl" data-id="element-143">
              {navLinks.map(link => {
            const cls = 'block px-3 py-4 text-cream font-medium tracking-widest uppercase text-center border-b border-white/5 hover:text-amber';
            if (link.isRoute) {
              return <Link key={link.name} to={link.href} onClick={() => setMobileMenuOpen(false)} className={cls} data-id="element-144">
                      {link.name}
                    </Link>;
            }
            if (location.pathname !== '/') {
              return <Link key={link.name} to={link.href} onClick={() => setMobileMenuOpen(false)} className={cls} data-id="element-145">
                      {link.name}
                    </Link>;
            }
            return <a key={link.name} href={link.href.replace('/', '')} onClick={() => setMobileMenuOpen(false)} className={cls} data-id="element-146">
                    {link.name}
                  </a>;
          })}
              <div className="pt-4 flex justify-center" data-id="element-147">
                <a href="#reservation" onClick={() => setMobileMenuOpen(false)} className="bg-amber text-charcoal px-8 py-3 font-semibold tracking-wide uppercase text-sm hover:bg-cream transition-colors inline-block" data-id="element-148">
                  Make a Reservation
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}